import { createContext, useContext } from 'react';

const IoContext = createContext('io');

const useIoContext = () => {
  return useContext(IoContext);
};

export { IoContext, useIoContext };
